import posthog from 'posthog-js'
import { isDevHost } from '@/utils/devHost'
import { isIgnoredError } from '@/utils/ignoredErrors'

// posthog-js puts exceptions on `$exception_list` as { type, value, stacktrace } objects,
// and mirrors the first one onto `$exception_message` / `$exception_type`.
// (There is no `$exception_values` property on the event - that name only exists
// internally, for evaluating server-side suppression rules.)
function shouldDropEvent (event) {
  if (!event || !event.properties) {
    return false
  }
  var props = event.properties

  if (isIgnoredError(props['$exception_message']) ||
      isIgnoredError(props['$exception_type'])) {
    return true
  }

  var exceptions = props['$exception_list']
  if (Array.isArray(exceptions)) {
    for (var i = 0; i < exceptions.length; i++) {
      var ex = exceptions[i]
      if (!ex) {
        continue
      }
      // Tolerate both the object shape and a bare string, just in case.
      if (typeof ex === 'string' ? isIgnoredError(ex)
        : (isIgnoredError(ex.value) || isIgnoredError(ex.type))) {
        return true
      }
    }
  }

  return false
}

export default {
  install(Vue, options) {
    Vue.prototype.$posthog = posthog.init(
      'phc_xDNVSjmfkWI4uJZTfWRTFzEUz9wG6ElLHry4XqDjcCv',
      {
        api_host: 'https://b.bytbostad.se',
        ui_host: 'https://eu.posthog.com',
        // This is a history-mode SPA: without this posthog-js only captures a
        // $pageview on the initial page load, so vue-router navigations
        // (/bostad/:id, /matchningar, ...) were never tracked.
        capture_pageview: 'history_change',
        before_send: function(event) {
          // On local dev: log to console instead of polluting production analytics
          if (isDevHost()) {
            console.log('[PostHog (dev)]', event && event.event, event)
            return null
          }
          // Drop known third-party library errors
          return shouldDropEvent(event) ? null : event
        }
      }
    )
  }
}
